import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CoreSvg from 'shared/CoreSvg';
import Icon from 'shared/icons';
import useCommonStore from 'store/useCommonStore';
import styled, { css } from 'styled-components';

interface INavList {
	name: string;
	icon: JSX.Element;
	url: string[];
	_onClick?: () => void;
}

const Gnb = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const { setKeyword } = useCommonStore();

	const nav_list: INavList[] = [
		{ name: 'Ranking', icon: <Icon.Graph />, url: ['/imms/rank', '/imms/'] },
		{
			name: 'Searching',
			icon: <Icon.Search />,
			url: ['/imms/search'],
			_onClick() {
				setKeyword('');
			},
		},
		{ name: 'Matching', icon: <Icon.List />, url: ['/imms/match?page=1', '/imms/match'] },
	];

	const isSelected = (url_arr: string[]) => url_arr.includes(location.pathname);

	return (
		<GnbWrapper>
			<NavList>
				{nav_list.map((item) => (
					<NavItem
						key={item.name}
						onClick={() => {
							navigate(item.url[0]);
							if (item._onClick) item._onClick();
						}}
						selected={isSelected(item.url)}
					>
						<IconWrapper>
							<CoreSvg>{item.icon}</CoreSvg>
						</IconWrapper>
						{item.name}
					</NavItem>
				))}
			</NavList>
		</GnbWrapper>
	);
};

const GnbWrapper = styled.nav`
	width: 80px;
	height: 100%;
	padding: 32px 12px;

	background-color: ${({ theme }) => theme.colors.gray.gray_white};
	border-right: 1px solid ${({ theme }) => theme.colors.gray.gray15};
`;

const NavList = styled.ul`
	width: 100%;
	height: 100%;

	${({ theme }) => theme.common.flexStart};
	flex-direction: column;
	gap: 24px;
`;

const NavItem = styled.li<{ selected: boolean }>`
	width: 56px;
	height: 56px;

	${({ theme }) => theme.typo.body.span_bold};

	${({ theme }) => theme.common.flexBetween};
	flex-direction: column;

	cursor: pointer;

	${({ selected, theme }) =>
		selected &&
		css`
			& > div {
				background-color: ${theme.colors.gray.gray10};
			}

			& > div > span > svg {
				fill: ${theme.colors.system.blue};
			}
		`}
`;

const IconWrapper = styled.div`
	width: 100%;
	height: 32px;
	border-radius: 16px;
	background-color: transparent;

	${({ theme }) => theme.common.flexCenter};
`;

export default Gnb;
